import React from 'react';

import ButtonWithPopover from './ButtonWithPopover';


import Button from 'react-bootstrap/Button';

const SaveDispositionPopover = (props) => {
  const { values, disallowEditing, disableActions, submitDisposition } = props;

  const handleSubmit = () => {
    submitDisposition(values);
  };

  const reference = "saveConfirmation";

  return (
    <ButtonWithPopover
      placement="top"
      customRef={reference + "bwp"}
      buttonVariant="success"
      buttonText="Save Disposition"
      buttonIsBlock={true}
      buttonIsDisabled={disallowEditing || disableActions}
      popoverTitle="Save Switch Disposition"
      buttonId='switchdisposition-btn-saveDisposition'
    >
      <p className="confirmation-text">
        Do you want to <b>save</b> this switch disposition?
      </p>
      <div className="align-content-right">
        <Button id='switchdisposition-btn-save' className="left-spacer" variant="success" onClick={handleSubmit}>
          Save
        </Button>
      </div>
    </ButtonWithPopover>
  );
};

export default SaveDispositionPopover;
